<div class="container container-fluid lh-container-fluid-sm">
  <h3>{{ 'RESET_PASSWORD' | translate }}</h3>
  <p>{{ 'CHOOSE_NEW_PASSWORD_TO_COMPLETE_RESET' | translate }}</p>

  <form class="user-form" [formGroup]="form" (submit)="onSubmit()">
    <div class="form-group">
      <input
        id="password"
        type="password"
        class="form-control"
        name="password"
        formControlName="password"
        [placeholder]="'PASSWORD' | translate"
      />
      @if (form.get('password').touched && form.get('password').invalid) {
        <div class="alert alert-danger mt-1">{{ 'CHANGE_PASSWORD_REQUIRED' | translate }}</div>
      }
    </div>

    <div class="form-group">
      <input
        id="confirmPassword"
        type="password"
        class="form-control"
        name="confirmPassword"
        formControlName="confirmPassword"
        [placeholder]="'CONFIRM_PASSWORD' | translate"
      />
      @if (form.get('password').valid && form.get('confirmPassword').touched && !arePasswordsEqual) {
        <div class="alert alert-danger mt-1">{{ 'CHANGE_PASSWORD_MISMATCH' | translate }}</div>
      }
    </div>

    <button class="btn btn-lg btn-warning" type="submit" tabindex="3" [disabled]="!canSubmit">
      {{ 'CHANGE_PASSWORD' | translate }}
    </button>
  </form>
</div>
